import { ReportWellnessSummaryData } from "../../models/interfaces/reports/report-wellness-summary-data";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { Redirect } from 'react-router-dom';
import ReportWellnessSummary from "../../components/report/report-wellness-summary";
import { WellnessProgramStatus } from "../../models/interfaces/wellness-program-status";

const ReportWellnessSummaryTestPage: React.FC = () => {
    const { state } = useAuthState();
    if (!state.claims.superAdmin) {
        return <Redirect push to="/" />;
    }

    const mockData: ReportWellnessSummaryData = {
        groupNames: ["Group A", "Group B"],
        organizationName: "Test Organization",
        reportDate: "2025-10-27",
        tagNames: ["Tag1", "Tag2"],
        filterNames: ["Active", "Pending"],
        totalUsers: 3,
        averageEngagement: 85,
        sevenDayEngagement: 90,
        thirtyDayEngagement: 80,
        averageDaysMissed: 2,
        averageStreak: 5,
        activePrograms: 2,
        pendingRetest: 1,
        enrolledUsers: 3,
        userData: [
            {
                id: "Asdasdsa",
                name: "Alice Example",
                programStatus: WellnessProgramStatus.Active,
                daysLeft: 10,
                daysMissed: 1,
                currentStreak: 7,
                sevenDayEngagement: 40,
                thirtyDayEngagement: 50,
                progressPercentage: 80
            },
            {
                id: "Asdasdsa",
                name: "Bob Example",
                programStatus: WellnessProgramStatus.Ended,
                daysLeft: 5,
                daysMissed: 3,
                currentStreak: 2,
                sevenDayEngagement: 39,
                thirtyDayEngagement: 49,
                progressPercentage: 60
            },
            {
                id: "Asdasdsa",
                name: "Charlie Example",
                programStatus: WellnessProgramStatus.Pending,
                daysLeft: 15,
                daysMissed: 0,
                currentStreak: 10,
                sevenDayEngagement: 95,
                thirtyDayEngagement: 90,
                progressPercentage: 85
            }
        ]
    }

    return <ReportWellnessSummary data={mockData} />;
}

export default ReportWellnessSummaryTestPage;
